import { ModalActivePassesComponent } from './modal-active-passes/modal-active-passes.component';
import { ModalAddPaxComponent } from './modal-add-pax/modal-add-pax.component';
import { ModalAddToAppComponent } from './modal-add-to-app/modal-add-to-app.component';
import { ModalAlterationComponent } from './modal-alteration/modal-alteration.component';
import { ModalBlockedUserBookingComponent } from './modal-blocked-user-booking/modal-blocked-user-booking.component';
import { ModalBlockUserComponent } from './modal-block-user/modal-block-user.component';
import { ModalChangeBookingAvailabilityComponent } from './modal-change-booking-availability/modal-change-booking-availaibity.component';
import { ModalChangeBookingKmsComponent } from './modal-change-booking-kms/modal-change-booking-kms.component';
import { ModalChangeBookingOriginDestinationComponent } from './modal-change-booking-origin-destination/modal-change-booking-origin-destination.component';
import { ModalChangeBookingSeatsComponent } from './modal-change-booking-seats/modal-change-booking-seats.component';
import { ModalChangeDriverComponent } from './modal-change-driver/modal-change-driver.component';
import { ModalChangeDriverVehicle } from './modal-change-driver-vehicle/modal-change-driver-vehicle';
import { ModalChangePasswordComponent } from './modal-change-password/modal-change-password.component';
import { ModalNotificationSettingsComponent } from './modal-notification-settings/modal-notification-settings.component';
import { NotificationTextsEditorComponent } from './modal-notification-settings/notification-texts-editor/notification-texts-editor.component';
import { ModalChangeVehicleComponent } from './modal-change-vehicle/modal-change-vehicle.component';
import { ModalDownloadRoadmapComponent } from './modal-download-roadmap/modal-download-roadmap.component';
import { ModalConfirmationComponent } from './modal-confirmation/modal-confirmation.component';
import { ModalConfirmationTextComponent } from './modal-confirmation-text/modal-confirmation-text.component';
import { ModalConfirmMultiConfigComponent } from './modal-confirm-multi-config/modal-confirm-multi-config.component';
import { ModalConfirmSetupUpdateComponent } from './modal-confirm-setup-update/modal-confirm-setup-update.component';
import { ModalConversationComponent } from './modal-conversation/modal-conversation.component';
import { ModalPublicTicketPreviewComponent } from './modal-public-ticket-preview/modal-public-ticket-preview.component';
import { ModalCreateBackupComponent } from './modal-create-backup/modal-create-backup';
import { ModalCreateFavouriteComponent } from './modal-create-favourite/modal-create-favourite.component';
import { ModalCreateScheduleComponent } from './modal-create-schedule/modal-create-schedule.component';
import { ModalCopySchedulesComponent } from './modal-copy-schedules/modal-copy-schedules.component';
import { ModalDuplicateAlterationComponent } from './modal-duplicate-alteration/modal-duplicate-alteration.component';
import { ModalDuplicateSetup } from './modal-duplicate-setup/modal-duplicate-setup';
import { ModalEditCommentComponent } from './modal-edit-comment/modal-edit-comment.component';
import { ModalEditScheduleComponent } from './modal-edit-schedule/modal-edit-schedule.component';
import { ModalEditTownComponent } from './modal-edit-town/modal-edit-town.component';
import { ModalExceedingKmLimitComponent } from './modal-exceeding-km-limit/modal-exceeding-km-limit.component';
import { ModalRestrictionWarningsComponent } from './modal-restriction-warnings/modal-restriction-warnings.component';
import { ModalExportGtfsComponent } from './modal-export-gtfs/modal-export-gtfs.component';
import { ModalFareComponent } from './modal-fare/modal-fare.component';
import { PromotionalCodesTabComponent } from './modal-fare/promotional-codes-tab/promotional-codes-tab.component';
import { TemporalPassesTabComponent } from './modal-fare/temporal-passes-tab/temporal-passes-tab.component';
import { ModalFavouriteRoutesComponent } from './modal-favourite-routes/modal-favourite-routes.component';
import { ModalGtfsComponent } from './modal-gtfs/modal-gtfs.component';
import { ModalHolidayCalendarComponent } from './modal-holiday-calendar/modal-holiday-calendar.component';
import { ModalMaxReservationTimeComponent } from './modal-max-reservation-time/modal-max-reservation-time.component';
import { ModalMessageDetailComponent } from './modal-message-detail/modal-message-detail.component';
import { ModalNewTownComponent } from './modal-new-town/modal-new-town.component';
import { ModalNotifiedBookingComponent } from './modal-notified-booking/modal-notified-booking.component';
import { ModalRouteDeparturesComponent } from './modal-route-departures/modal-route-departures.component';
import { ModalTicketingStatusComponent } from './modal-ticketing-status/modal-ticketing-status.component';
import { ModalUpdateDocumentsComponent } from './modal-update-documents/modal-update-documents.component';
import { ModalUploadExcelComponent } from './modal-upload-excel/modal-upload-excel.component';
import { ModalViewBookingsComponent } from './modal-view-bookings/modal-view-bookings.component';
import { ModalConfirmChangesComponent } from './route-design/modal-confirm-changes/modal-confirm-changes.component';

export {
  ModalCopySchedulesComponent,
  ModalActivePassesComponent,
  ModalAddPaxComponent,
  ModalAddToAppComponent,
  ModalAlterationComponent,
  ModalBlockedUserBookingComponent,
  ModalBlockUserComponent,
  ModalDownloadRoadmapComponent,
  ModalChangeBookingAvailabilityComponent,
  ModalChangeBookingKmsComponent,
  ModalChangeBookingOriginDestinationComponent,
  ModalChangeBookingSeatsComponent,
  ModalChangeDriverComponent,
  ModalChangeDriverVehicle,
  ModalChangePasswordComponent,
  ModalNotificationSettingsComponent,
  NotificationTextsEditorComponent,
  ModalChangeVehicleComponent,
  ModalConfirmationComponent,
  ModalConfirmationTextComponent,
  ModalConfirmMultiConfigComponent,
  ModalConfirmSetupUpdateComponent,
  ModalConversationComponent,
  ModalPublicTicketPreviewComponent,
  ModalCreateBackupComponent,
  ModalCreateFavouriteComponent,
  ModalCreateScheduleComponent,
  ModalDuplicateAlterationComponent,
  ModalDuplicateSetup,
  ModalEditCommentComponent,
  ModalEditScheduleComponent,
  ModalEditTownComponent,
  ModalExceedingKmLimitComponent,
  ModalRestrictionWarningsComponent,
  ModalExportGtfsComponent,
  ModalFareComponent,
  PromotionalCodesTabComponent,
  TemporalPassesTabComponent,
  ModalFavouriteRoutesComponent,
  ModalGtfsComponent,
  ModalHolidayCalendarComponent,
  ModalMaxReservationTimeComponent,
  ModalMessageDetailComponent,
  ModalNewTownComponent,
  ModalNotifiedBookingComponent,
  ModalRouteDeparturesComponent,
  ModalTicketingStatusComponent,
  ModalUpdateDocumentsComponent,
  ModalUploadExcelComponent,
  ModalViewBookingsComponent,
  ModalConfirmChangesComponent,
};

export const modals = [
  ModalActivePassesComponent,
  ModalAddPaxComponent,
  ModalAddToAppComponent,
  ModalAlterationComponent,
  ModalBlockedUserBookingComponent,
  ModalBlockUserComponent,
  ModalDownloadRoadmapComponent,
  ModalChangeBookingAvailabilityComponent,
  ModalChangeBookingKmsComponent,
  ModalChangeBookingOriginDestinationComponent,
  ModalChangeBookingSeatsComponent,
  ModalChangeDriverComponent,
  ModalChangeDriverVehicle,
  ModalChangePasswordComponent,
  ModalChangeVehicleComponent,
  ModalConfirmationTextComponent,
  ModalConfirmMultiConfigComponent,
  ModalConfirmSetupUpdateComponent,
  ModalConversationComponent,
  ModalPublicTicketPreviewComponent,
  ModalCreateBackupComponent,
  ModalCreateFavouriteComponent,
  ModalCreateScheduleComponent,
  ModalDuplicateAlterationComponent,
  ModalDuplicateSetup,
  ModalEditCommentComponent,
  ModalEditScheduleComponent,
  ModalEditTownComponent,
  ModalExceedingKmLimitComponent,
  ModalRestrictionWarningsComponent,
  ModalExportGtfsComponent,
  ModalFareComponent,
  PromotionalCodesTabComponent,
  TemporalPassesTabComponent,
  ModalFavouriteRoutesComponent,
  ModalGtfsComponent,
  ModalHolidayCalendarComponent,
  ModalMaxReservationTimeComponent,
  ModalMessageDetailComponent,
  ModalNewTownComponent,
  ModalNotifiedBookingComponent,
  ModalRouteDeparturesComponent,
  ModalTicketingStatusComponent,
  ModalUpdateDocumentsComponent,
  ModalUploadExcelComponent,
  ModalViewBookingsComponent,
  ModalConfirmChangesComponent,
]
